<template functional>
  <component
    :is="injections.components.Panel"
    :variant="['transparent']"
    class="d-flex align-items-center list-item-placeholder"
  >
    <div class="d-flex align-items-center">
      <div class="avatar-placeholder h-mr-3"></div>
      <div class="text-placeholder"></div>
    </div>
  </component>
</template>

<script>
import Panel from '@/components/atoms/Panel';

export default {
  name: 'ListItemPlaceholder',
  props: {
    height: {
      type: Number,
      default: 98,
    },
  },
  inject: {
    components: {
      default: {
        Panel,
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.list-item {
  &-placeholder {
    border: 2px dashed $new-fg-disabled;
    border-radius: 5px;
    height: 4rem;
    padding: 1rem;
    .avatar-placeholder,
    .text-placeholder {
      display: block;
      background: var(--ph-card);
    }
    .avatar-placeholder {
      width: 48px;
      height: 48px;
      border-radius: 12px;
    }
    .text-placeholder {
      width: 10rem;
      height: 24px;
      border-radius: 4px;
      @media (max-width: 600px) {
        width: 7rem;
      }
    }
  }
}
</style>
